// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__vSHbq","title":"ClientReferral_title__3z_7E","itemText":"ClientReferral_itemText__2pHHN"};